import { useEffect, useState, memo } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@mui/material/TextField';
import { Formik, useFormik, FormikProvider, Field } from 'formik';
import {DebounceInput} from 'react-debounce-input';

const fragmentRowName = memo((props) => {
    const data = props.data;
    const submitShowError = props.submitShowError;
    const updateFragment = props.updateFragment;
    const errorName = props.errorName;

    return (
        <Grid item>
            <DebounceInput
                debounceTimeout={500}
                minLength={1}
                element={TextField}
                required
                multiline
                id="sample-name"
                variant="outlined"
                sx={{ '& .MuiInputBase-root': { width: 180, minHeight: 40, borderRadius: 0, borderColor: 'black' },'& legend': { display: 'none' },
                '& fieldset': { top: 0 }, "& .MuiInputBase-input": {
                  marginTop: -2,
                  marginBottom: -2
                }}}
                inputProps={{ spellCheck: false }}
                label={undefined}
                placeholder="Sample Name"
                value={data.sampleName}
                onBlur={(e) => {
                  var newTouched = [...data.touched];
                  newTouched[0] = true;
                  updateFragment({ touched: newTouched }, props.id);
                  
                }}
                onChange={(e) => {
                  var newTouched = [...data.touched];
                  newTouched[0] = true;
                  updateFragment({ sampleName: e.target.value, touched: newTouched }, props.id);
                }}
                error={((submitShowError)) && errorName(data.sampleName)}
              />
        </Grid>
    )
});

export default fragmentRowName;